'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChatbubbleQuestionFill from '@common/icon/SvgChatbubbleQuestionFill';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';
import { useCheckKakaobank } from '@/hooks/useCheckKakaobank';
import { usePartnerChromeClassName } from '@/hooks/usePartnerChromeClassName';
import { Agencies } from './Agencies';
import { RegionFinderDropdown } from './RegionFinderDropdown';
const DONATION_SUB_HEADER_HEIGHT = 56;
const DONATION_DESKTOP_HEADER_HEIGHT = 72;
export const DONATION_DESKTOP_STICKY_TOP = DONATION_DESKTOP_HEADER_HEIGHT + DONATION_SUB_HEADER_HEIGHT;
export const DonationSubHeader = () => {
  const $ = _c(26);
  const partnerChromeClassName = usePartnerChromeClassName();
  const pathname = usePathname();
  const isKakaobank = useCheckKakaobank();
  let t0;
  if ($[0] !== partnerChromeClassName) {
    t0 = cn(partnerChromeClassName, "sticky z-10 w-full bg-Gray-white mobile:hidden tablet:hidden");
    $[0] = partnerChromeClassName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      top: DONATION_DESKTOP_HEADER_HEIGHT,
      height: DONATION_SUB_HEADER_HEIGHT
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li><RegionFinderDropdown /></li>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = DONATION_ROUTES.GIFTS.pathname === pathname;
  let t4;
  if ($[4] !== t3) {
    t4 = <SubLink href={DONATION_ROUTES.GIFTS.pathname} isSelected={t3}>답례품</SubLink>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname === pathname;
  let t6;
  if ($[6] !== t5) {
    t6 = <SubLink href={DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname} isSelected={t5}>지정기부사업</SubLink>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = DONATION_ROUTES.MY_ETC_EVENT.pathname === pathname;
  let t8;
  if ($[8] !== t7) {
    t8 = <SubLink href={DONATION_ROUTES.MY_ETC_EVENT.pathname} isSelected={t7}>이벤트</SubLink>;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = DONATION_ROUTES.GUIDE.pathname === pathname;
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SvgChatbubbleQuestionFill className="ml-4 size-16 text-B-500" />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t9) {
    t11 = <SubLink href={DONATION_ROUTES.GUIDE.pathname} isSelected={t9}>고향사랑기부 안내{t10}</SubLink>;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11 || $[14] !== t4 || $[15] !== t6 || $[16] !== t8) {
    t12 = <ul className="flex items-center gap-12">{t2}<li className="flex items-center">{t4}{t6}{t8}{t11}</li></ul>;
    $[13] = t11;
    $[14] = t4;
    $[15] = t6;
    $[16] = t8;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== isKakaobank) {
    t13 = !isKakaobank && <Agencies />;
    $[18] = isKakaobank;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12 || $[21] !== t13) {
    t14 = <nav className="mx-auto flex h-full max-w-screen-xl items-center justify-between px-40">{t12}{t13}</nav>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t0 || $[24] !== t14) {
    t15 = <div className={t0} style={t1}>{t14}</div>;
    $[23] = t0;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
};
const SubLink = t0 => {
  const $ = _c(7);
  const {
    href,
    isSelected,
    children
  } = t0;
  const t1 = isSelected ? "page" : undefined;
  const t2 = isSelected ? "font-700 text-Gray-800" : "font-600 text-Gray-700 hover:text-Gray-900";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("flex h-56 items-center px-24 transition-colors typo-body3", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== href || $[4] !== t1 || $[5] !== t3) {
    t4 = <CustomLink href={href} aria-current={t1} className={t3}>{children}</CustomLink>;
    $[2] = children;
    $[3] = href;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};